<div class="demo-app home-element">
  <div class="header-row">
    <h2><i class="pi pi-calendar"></i> Mi Agenda</h2>
    <div class="header-buttons">
      <p-button (click)="resetFilters()" icon="pi pi-filter-slash" label="Limpiar filtros" severity="danger"></p-button>
      <p-button (click)="handlePrintCalendar()" icon="pi pi-file-pdf" label="Imprimir"></p-button>
    </div>
  </div>

  <p-accordion class="calendar-filters">
    <p-accordionTab header="Filtrar calendario">
      <form [formGroup]="filterForm" class="filter-grid" (ngSubmit)="applyFilters()">
        <input pInputText formControlName="search" placeholder="Buscar folio o servicio">
        <p-dropdown [options]="statuses" optionLabel="name" optionValue="name" formControlName="status__name"
          placeholder="Estatus" [showClear]="true"></p-dropdown>
        <p-dropdown [options]="eventTypes" optionLabel="name" optionValue="id" formControlName="event_type"
          placeholder="Tipo de evento" [showClear]="true"></p-dropdown>
        <p-dropdown [options]="serviceTypes" optionLabel="name" optionValue="id" formControlName="service_type"
          placeholder="Tipo de servicio" [showClear]="true"></p-dropdown>
        <p-button type="submit" icon="pi pi-filter" label="Filtrar"></p-button>
      </form>
    </p-accordionTab>
  </p-accordion>

  <p-accordion class="calendar-legend">
    <p-accordionTab header="Simbología del calendario">
      <div class="legend-items">
        <span>📅 Evento normal</span>
        <span>🔄 Evento recurrente</span>
        <span>🔚 Último evento</span>
        <span>⏭️ Penúltimo evento</span>
        <span>♾️ Evento infinito</span>
      </div>
    </p-accordionTab>
  </p-accordion>

  <div class="calendar-container">
    <full-calendar [options]="calendarOptions" #fullCalendar></full-calendar>
  </div>

  <p-dialog [modal]="true" [(visible)]="isModalVisible" [style]="{ width: '30rem' }">
    <ng-template pTemplate="header">
      <div class="dialog-header"><i class="pi pi-file-pdf"></i><span>Documentos de {{ selectedEvent?.title || 'evento' }}</span></div>
    </ng-template>
    <ul class="list-of-documents">
      @if (isModalLoading) {
        <li class="no-documents"><i class="pi pi-spin pi-spinner"></i></li>
      } @else if (documents.length === 0) {
        <li class="no-documents">No hay documentos</li>
      }
      @for (document of documents; track document.url) {
        <li class="list-document-element">
          <button class="document-item" (click)="handleOpenDocument(document)"><i class="pi pi-file-pdf"></i>{{ document.name }}</button>
          <button class="document-download" (click)="handleDownloadDocument(document)"><i class="pi pi-download"></i></button>
        </li>
      }
    </ul>
  </p-dialog>

  <p-dialog [modal]="true" [(visible)]="iframeModalVisible" [style]="{ width: '80%' }">
    <ng-template pTemplate="header">
      <div class="dialog-header"><i class="pi pi-file-pdf"></i><span>{{ selectedDocument?.name || (isForCalendar ? 'Calendario' : 'Documento') }}</span></div>
    </ng-template>
    @if (isModalLoading) { <span class="no-documents"><i class="pi pi-spin pi-spinner"></i></span> }
    @if (documentUrl) { <iframe [src]="documentUrl | safeUrl" width="100%" height="500" frameborder="0"></iframe> }
  </p-dialog>
</div>
